module.exports = __webpack_public_path__ + "img/rec-15.8ad36ea4.png";